export default function Background() {
  return (
    <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-sky-900/40 via-indigo-900/30 to-zinc-950/80" />
      <div className="bg-grid absolute inset-0 opacity-60" />
    </div>
  );
}